import cx from 'classnames';
import PropTypes from 'prop-types';

import * as style from './cell.module.scss';

const Cell = ({ children, className, size }) => {
  return (
    <div className={cx(style.cell, style[`cell${size}`], className)}>
      {children}
    </div>
  );
};

Cell.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  size: PropTypes.oneOf([2, 3]).isRequired,
};

export default Cell;
